export const PermissionTemplateEmail = {
    PUT: "mgr-template-email-**-PUT",
    POST: "mgr-template-email-POST",
    DELETE: "mgr-template-email-**-DELETE",
    GET: "mgr-template-email-search-GET",
    GET_UUID: "mgr-template-email-**-GET"
};